import { AppwriteException } from "@appwrite.io/console";
import { createConsoleClient, createProjectClient } from "../appwrite-client";

export async function getImaginePreviewToken({
  projectId,
}: {
  projectId: string;
}) {
  const consoleClient = createConsoleClient();
  const projectClient = createProjectClient(projectId);
  const account = consoleClient.account;

  let user: Awaited<ReturnType<typeof account.get>> | null = null;

  try {
    user = await account.get();
  } catch (error) {
    console.log("Error getting default user session", error);
  }

  if (!user) {
    throw new Error("User not found for token");
  }

  let existingProjectUser: Awaited<
    ReturnType<typeof projectClient.users.get>
  > | null = null;

  try {
    existingProjectUser = await projectClient.users.get(user.$id);
  } catch (error) {
    if (error instanceof AppwriteException) {
      if (error.code === 404) {
        existingProjectUser = null;
      } else {
        throw error;
      }
    }
  }

  if (!existingProjectUser) {
    // Create user in project DB
    const newUser = await projectClient.users.create({
      userId: user.$id,
      email: user.email,
      name: user.name,
    });
    existingProjectUser = await projectClient.users.get(newUser.$id);
  }

  const createdToken = await projectClient.users.createJWT(
    existingProjectUser.$id,
    "imagine-embedded-user-session",
    60 * 60 * 1,
  );
  return createdToken.jwt;
}
